import getConfig from 'Util/Config';

import { PRODUCT_TYPE, CUSTOMER_TYPE } from './constants';

export const filterListedColumns = (columns) => {
  const { salesUnlistedColumns } = getConfig();
  if (salesUnlistedColumns && salesUnlistedColumns?.length !== 0) {
    return columns.filter((col) => !salesUnlistedColumns.includes(col?.Header));
  }
  return columns;
};

export const calcSalesExclVAT = (priceInclVAT, discountIncVAT, vat) => {
  return priceInclVAT - discountIncVAT - vat;
};

export const calcSalesExclWHT = (priceInclVAT, discountIncVAT, withholdingTax) => {
  return priceInclVAT - discountIncVAT - withholdingTax;
};

export const calcRemainDiscountCode = (oldTotal, newTotal, oldRemain) => {
  if (isNaN(oldTotal) || isNaN(newTotal) || isNaN(oldRemain)) {
    return 0;
  }
  const usedCode = oldTotal - oldRemain;
  return newTotal - usedCode;
};

/**
 * Normalize the shared discount-code option fields into the shape the API expects.
 * Mutates and returns `value`. Used by both single-create (transformDiscount) and
 * batch-create (formatData) so the two forms stay in lockstep.
 * - learning conditions: daysBeforeExpiry -> [{ days }], expiryDate -> [{ expiryDate }], else null
 * - customerType: null when unset or ALL
 * - minimumQuantity: null when unset or 'unselected'
 * - validationType: UI-only, always stripped
 */
export const normalizeDiscountOptions = (value) => {
  // validationType only drives which expiry field is shown; never sent to the API
  delete value.validationType;

  const takeKey = (key) => {
    const data = value[key];
    if (key in value) delete value[key];
    return data;
  };
  const daysBeforeExpiry = takeKey('daysBeforeExpiry');
  const expiryDate = takeKey('expiryDate');
  if (daysBeforeExpiry) value.conditions = [{ days: daysBeforeExpiry }];
  else if (expiryDate) value.conditions = [{ expiryDate }];
  else value.conditions = null;

  if (!value.customerType || value.customerType === CUSTOMER_TYPE.ALL) {
    value.customerType = null;
  }

  if (!value.minimumQuantity || value.minimumQuantity === 'unselected') {
    value.minimumQuantity = null;
  }

  return value;
};

export const genProductTypesSKUText = (productType) => {
  switch (productType) {
    case PRODUCT_TYPE.ONLINE_COURSE:
      return 'ALL COURSES';
    case PRODUCT_TYPE.BUNDLE:
      return 'ALL BUNDLES';
    default:
      return '';
  }
};
